import React from 'react'

export const Header = () => {
  return (
    <div>
        <div className="parallax">
            <div className="parallax-content">
                <div className='row'>
                    <div className='col-md-2'></div>
                    <div className='col-md-8'>
                    <h1>We Change Everything WordPress</h1>
                <p>This is the only WordPress theme you will ever want to use.</p>
                <button className='btn1'>Read More</button>
                <button className='btn2'>Download Now</button>
                    </div>
                    <div className='col-md-2'></div>

                </div>

            </div>
        </div>
    </div>
  )
}
